import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 5,
	viewBox: "0 0 30 5",
	stroke: "white",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("line", {
		x1: 1.48403e-7,
		y1: 2.5,
		x2: 30,
		y2: 2.5,
		strokeWidth: 5,
		fill: "none"
	})
});
export default SvgLine;
